import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../utils';

export const EditProfileViewApi = createAsyncThunk(
  'EditProfileView',
  async (editProfilePayload, { dispatch }) => {
    dispatch({ type: 'EditProfileView/pending', payload: {} });

    const { customerId, Authorization, customerRefNum } = editProfilePayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'dashboardmenus/edit_profile/view',
      payload: {
        customerRefNum,
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        dispatch({ type: 'EditProfileView/fulfilled', payload: res });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'EditProfileView/rejected', payload: err });
      },
    });
  }
);

export const EditProfileView_extrareducer = {
  [EditProfileViewApi.pending]: (state, action) => {
    state.editProfileDetailsApiState.isLoading = true;
  },
  [EditProfileViewApi.fulfilled]: (state, action) => {
    state.editProfileDetailsApiState.isLoading = false;
    state.editProfileDetailsApiState.isSuccess = true;
    state.editProfileDetailsApiState.isError = false;
    state.editProfileDetailsApiState.response = action.payload;
  },
  [EditProfileViewApi.rejected]: (state, action) => {
    state.editProfileDetailsApiState.isLoading = false;
    state.editProfileDetailsApiState.isSuccess = false;
    state.editProfileDetailsApiState.isError = true;
    state.editProfileDetailsApiState.response = action.payload;
  },
};
